import { z } from "zod";
export const SiteReleaseRollbackRehearsalStepV1Schema = z
    .object({
    stepId: z.string().min(1),
    label: z.string().min(1),
    outcome: z.enum(["PASS", "FAIL", "SKIPPED"]),
})
    .strict();
export const SiteReleaseRollbackRehearsalRecordV1Schema = z
    .object({
    schemaVersion: z.literal("site-release-rollback-rehearsal.v1.0"),
    releaseId: z.string().min(1),
    restoredToReleaseId: z.string().min(1),
    steps: z.array(SiteReleaseRollbackRehearsalStepV1Schema).min(1),
    recordedAt: z.string().datetime(),
})
    .strict();
const REQUIRED_STEP_IDS = ["identify_known_good", "restore_artifact", "smoke_check"];
export function recordSiteReleaseRollbackRehearsal(input) {
    const parsed = SiteReleaseRollbackRehearsalRecordV1Schema.parse({
        schemaVersion: "site-release-rollback-rehearsal.v1.0",
        ...input,
    });
    const ids = new Set(parsed.steps.map((step) => step.stepId));
    for (const required of REQUIRED_STEP_IDS) {
        if (!ids.has(required)) {
            throw new Error(`rollback_rehearsal_missing_step:${required}`);
        }
    }
    if (!parsed.steps.every((step) => step.outcome === "PASS" || step.outcome === "SKIPPED")) {
        throw new Error("rollback_rehearsal_failed_step");
    }
    return parsed;
}
//# sourceMappingURL=site-release-rollback-rehearsal.js.map